import type {PS, Pointer} from '@wix/document-services-types'
import {COMP_TYPES} from '@wix/document-manager-extensions/src/constants/constants'

import appStudioDataModel from './appStudioDataModel'
import componentDetectorAPI from '../componentDetectorAPI/componentDetectorAPI'
import componentCode from '../component/componentCode'

interface SlotPlaceholderData {
    compRefId: string
    slotKeyName: string
}

function getSlotPlaceholdersDataByPointer(ps: PS, widgetDataPointer: Pointer): SlotPlaceholderData[] {
    const widgetRef = appStudioDataModel.getAppWidgetRefFromPointer(ps, widgetDataPointer)
    const slotPlaceholders = componentDetectorAPI.getComponentByType(ps, COMP_TYPES.SLOT_PLACEHOLDER, widgetRef)

    return slotPlaceholders.map(slotPlaceholderRef => {
        return {
            compRefId: slotPlaceholderRef.id,
            slotKeyName: componentCode.getNickname(ps, slotPlaceholderRef)
        }
    })
}

export default {
    getSlotPlaceholdersDataByPointer
}
